import React from "react";

export type RumErrorEvent = {
  message: string;
  data: Record<string, unknown>;
};

function createRumErrorSignature(rumError: RumErrorEvent): string {
  try {
    return JSON.stringify([rumError.message, rumError.data]);
  } catch {
    return rumError.message;
  }
}

type DatadogRumErrorsProps = {
  rumErrors?: RumErrorEvent[];
};

export function DatadogRumErrors({ rumErrors }: DatadogRumErrorsProps) {
  const reportedErrorsRef = React.useRef<Set<string>>(new Set());

  React.useEffect(() => {
    if (!rumErrors?.length) {
      return;
    }

    for (const rumError of rumErrors) {
      const signature = createRumErrorSignature(rumError);
      if (reportedErrorsRef.current.has(signature)) {
        continue;
      }

      reportedErrorsRef.current.add(signature);
      const error = new Error(rumError.message);
      window.DD_RUM?.onReady(() => {
        window.DD_RUM?.addError(error, {
          data: rumError.data,
        });
      });
    }
  }, [rumErrors]);

  return null;
}
